export const SET_BILLING = 'Set billing'
export const DELETE_BILLING = 'Delete billing'
export const UPDATE_BILLING = 'Update billing'
export const SET_ACCOUNTS = 'Set single patient accounts'
